export default {
  title: 'Пользователи',
  user: 'Пользователь',
  users: 'Пользователи',

  titles: {
    create: 'Создать нового пользователя',
    token: 'API ключ',
    presets: 'Пресеты',

    add: {
      funds: 'Пополнить баланс'
    }
  },

  contents: {
    routingGroups: {
      confirm: {
        remove: 'Подтвердите удаление группы маршрутизаций только из настроек текущего пользователя.'
      }
    }
  },

  labels: {
    owner: 'Владелец',
    username: 'Имя пользователя',
    password: 'Пароль',
    reseller: 'Реселлер',
    manager: 'Менеджер',
    referralCode: 'Реферальный код пользователя',
    target: 'нет имён отправителей | одно имя отправителя | {count} имён отправителей(я)',
    sendernames: 'Имена отправителей',
    patterns: 'Паттерны',

    isActive: {
      true: 'Доступ в кабинет разрешён',
      false: 'Доступ в кабинет ограничен'
    },

    strict: {
      true: 'Строгое соответствие включено',
      false: 'Строгое соответствие отключено',
      undefined: 'Строгое соответствие не определено'
    },

    data: {
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'E-mail',
      phone: 'Телефон',

      partnership: {
        hasContract: {
          true: 'Договор заключён',
          false: 'Договор не заключён',
          undefined: 'Статус договора не определён'
        }
      },

      meta: {
        source: 'Источник',
        usedReferralCode: 'Использованный реферальный код'
      }
    },

    no: {
      manager: 'Нет менеджера'
    }
  },

  tabs: {
    general: 'Основное',
    settings: 'Настройки',
    settingsUser: 'Настройки',
    permissions: 'Права',
    tariffs: 'Тарифы',
    routingGroups: 'Маршруты',
    processMessages: 'Обработка сообщений',
    requisites: 'Реквизиты',
    whatsapp: 'WhatsApp',
    recurrentPayments: 'Автоплатежи',
    referral: 'Реферальные пополнения',
    tokens: 'Токены',
    eventsHistory: 'История событий',
    eventsHistoryTab: 'История изменений',
    userComments: 'Комментарии',
    userChannels: 'ОТП Каналы',
    domainsUsers: 'Домены',
    advanced: 'Расширенные',
    granular: 'Гранулярные',
    secret: 'Секретные'
  },

  hints: {
    password: 'Придумайте надёжный пароль'
  },

  infos: {
    associationsByType: `
<strong>Переключатель строгого соответствия</strong> - это отдельная
настройка пользователя. Он не относится к данным пользователя.<br>
Чтобы избежать случайного включения или выключения, добавлена кнопка
подтверждения <strong>Сохранить</strong>.<br><br>

<i>После каждого изменения переключателя</i> строгого соответствия нужно нажимать
<strong>Сохранить</strong>, потому что теперь это изменение не сохраняется
автоматически.<br><br>

Если строгое соответствие включено для поля <strong>Имена отправителей</strong>,
пользователь сможет использовать при создании сообщения только выбранные
имена отправителей.<br>
Если строгое соответствие включено для поля <strong>Паттерны</strong>, при
модерации сообщений пользователя будут применяться только выбранные паттерны.<br><br>

Поля <strong>Имена отправителей</strong> и
<strong>Паттерны</strong> - это часть данных пользователя.<br>
Изменения в этих полях сохраняются только по нажатию кнопки
<strong>Обновить</strong>.
`
  },

  warnings: {
    apiKey: 'К сожалению, API ключ превышает допустимую длину. Попробуйте изменить имя пользователя и перезагрузить страницу или обратитесь к вашему менеджеру за помощью.',
    noTypes: 'Нет доступных типов отправлений.',

    permissions: {
      strict: {
        sendernames: 'У вас недостаточно прав для просмотра строгого соответствия имён отправителей.',
        patterns: 'У вас недостаточно прав для просмотра строгого соответствия паттернов.'
      }
    }
  },

  errors: {
    permissions: {
      get: {
        messageRuleGroups: 'У вас недостаточно прав для просмотра групп правил обработки сообщений.'
      }
    }
  },

  tooltips: {
    name: 'Имя: {name}',
    overdraft: 'Перерасход: {overdraft}',
    reseller: 'Реселлер: {reseller}',
    manager: 'Менеджер: {manager}',
    isActive: 'Флаг управляет доступом пользователя к платформе. Это часть данных пользователя, поэтому изменения сохраняются только после нажатия кнопки "Обновить".',
    isVerifiedByPhone: 'Телефон подтверждён, изменения отключены. Если вы хотите изменить номер телефона, пожалуйста, обратитесь в поддержку.',
    user: `Имя: {firstName}
Фамилия: {lastName}
Телефон: {phone}
E-mail: {email}
`,

    data: {
      meta: {
        isVerifiedByPhone: 'Включает или отключает подтверждение телефона. Изменение сохраняется только после нажатия кнопки "Обновить".'
      }
    },

    add: {
      funds: 'Пополнить баланс'
    },

    generate: {
      document: 'Скачать документ',
      password: 'Сгенерировать пароль'
    },

    copy: {
      apiKey: 'Скопировать API ключ',

      referral: {
        code: 'Скопировать реферальный код',
        link: 'Скопировать реферальную ссылку'
      }
    },

    strict: {
      sendernames: 'Пользователь сможет использовать только выбранные в поле ниже имена отправителей при создании сообщения.',
      patterns: 'При модерации сообщений пользователя, будут применяться только выбранные в поле ниже паттерны.'
    }
  },

  buttons: {
    account: 'Профиль',
    password: 'Изменить пароль'
  },

  snackbars: {
    created: 'Пользователь успешно создан.',
    updated: 'Пользователь успешно обновлён.',
    removed: 'Пользователь успешно удалён.',
    linkCopied: 'Ссылка успешно скопирована.',
    refCopied: 'Реферальный код успешно скопирован.',

    copy: {
      apiKey: 'API ключ успешно скопирован.'
    }
  }
}

